export const PAYMENT_TYPE_PAYPAL = 'PayPal'
export const PAYMENT_TYPE_CREDIT_CARD = 'CreditCard'

export const USER_SUBSCRIPTION_STATUS_CANCELLED = 'Cancelled'
export const USER_SUBSCRIPTION_STATUS_PAUSED = 'Paused'
export const USER_SUBSCRIPTION_STATUS_ACTIVE = 'Active'
export const USER_PAYMENT_SOURCE_LAST_TRANSACTION_STATUS_DECLINED = 'Declined'

export const SORT_ORDER_ASC = 'ASC'
export const SORT_ORDER_DESC = 'DESC'

/**
 * Default timezone for the admin app
 * Mountain Time (America/Denver) - handles MST/MDT automatically
 */
export const TIMEZONE_MOUNTAIN = 'America/Denver'

export const MENU_ITEMS = [
  {
    label: 'Abuse Report Center',
    path: '/user-abuse',
  },
  {
    label: 'Assets Management',
    path: '/assets-management',
  },
  {
    label: 'Clips',
    path: '/clips',
  },
  {
    label: 'Comments',
    path: '/comments/list',
  },
  {
    label: 'Content Full Text Search Management',
    path: '/content-search',
  },
  {
    label: 'Content Management',
    path: '/v2/content',
  },
  {
    label: 'Content Policy Management',
    path: '/content-policy',
  },
  {
    label: 'Event Management',
    path: '/live-event-management',
  },
  {
    label: 'Finance & Billing',
    path: '/finance',
  },
  {
    label: 'Gift Management',
    path: '/gift-management',
  },
  {
    label: 'Image Upload Simple',
    path: '/images/upload-simple',
  },
  {
    label: 'Images By Content',
    path: '/images/manage-by-content',
  },
  {
    label: 'Images Upload Bulk',
    path: '/images/upload-bulk',
  },
  {
    label: 'Media Management',
    path: '/v2/media',
  },
  {
    label: 'Marketing Hub',
    path: '/marketing-hub',
  },
  {
    label: 'Menus Management',
    path: '/manage-menus',
  },
  {
    label: 'Merchandising Campaigns',
    path: '/merchandising-campaigns',
  },
  {
    label: 'Notification Center',
    path: '/notifications',
  },
  {
    label: 'Page Management',
    path: '/page-manager',
  },
  {
    label: 'Partner Dashboard',
    path: '/ambassadors',
  },
  {
    label: 'Plan Management',
    path: '/plan-management',
  },
  {
    label: 'Product Management',
    path: '/product-management',
  },
  {
    label: 'QA',
    path: '/qa',
  },
  {
    label: 'Speech prototype',
    path: '/stt-tts',
  },
  {
    label: 'Text Tracks Bulk Upload',
    path: '/text-tracks',
  },
  {
    label: 'Transcript Chunk Search',
    path: '/transcript-chunk-search',
  },
  {
    label: 'URL Redirects Management',
    path: '/url-redirects',
  },
  {
    label: 'User Moderation',
    path: '/user-moderation',
  },
  {
    label: 'User Tags',
    path: '/manage-tags',
  },
  {
    label: 'Users Management',
    path: '/user-search',
  },
  {
    label: 'Video Analytics',
    path: '/video-analytics',
  },
  {
    label: 'Visualizers',
    path: '/visualizers',
  },
]
